import { T } from 'src/shared/helpers';
import AddProduct from '../steps/1-addProduct';
import ConnectCatalog from '../steps/2-connectCatalog';
import PrintAreas from '../steps/3-printAreas';
import Variants from '../steps/4-variants/variants';
import Preview from '../steps/5-preview';
import Done from '../steps/6-done';
import Composer from '../steps/configurator-composer';
import SceneEditor from '../steps/configurator-scene-editor';
import ShoppingPreview from '../steps/configurator-shopping-preview';
import PCStepSelection from '../steps/configurator-steps-selection';
import ProviderSelection from '../steps/pod-1-provider-selection';
import ImportCatalog from '../steps/pod-2-importCatalog';
import { EditConfiguration, ImportConfiguration } from '../steps/pod-3-import-configuration';
import PodDone from '../steps/pod-4-done';
import { backofficeUrl } from './../../../../shared/helpers';

const pages = [
    {
        key: 'add-product',
        url: backofficeUrl('/product/add-product'),
        title: T._('Select Source', 'Admin'),
        component: AddProduct,
        inEdit: false,
        mode: 'none'
    },
    {
        key: 'connect-catalog',
        url: backofficeUrl('/product/connect-catalog'),
        title: T._('Choose Product', 'Admin'),
        component: ConnectCatalog,
        inEdit: false,
        mode: 'classic'
    },
    {
        key: 'print-area',
        url: backofficeUrl('/product/print-area/'),
        title: T._('Setup product', 'Admin'),
        component: PrintAreas,
        inEdit: true,
        mode: 'classic'
    },
    { key: 'variations', url: backofficeUrl('/product/variations/'), title: T._('Variations', 'Admin'), component: Variants, inEdit: true, mode: 'classic' },
    { key: 'preview', url: backofficeUrl('/product/preview'), title: T._('Review', 'Admin'), component: Preview, inEdit: true, mode: 'classic' },
    {
        key: 'supplier-selection',
        url: backofficeUrl('/product/supplier-selection'),
        title: T._('Supplier Selection', 'Admin'),
        component: ProviderSelection,
        inEdit: false,
        mode: 'pod'
    },
    {
        key: '3D-product-configuration-steps',
        url: backofficeUrl('/product/3D-product-configuration-steps'),
        title: T._('3D Product Configuration Steps', 'Admin'),
        component: PCStepSelection,
        inEdit: true,
        mode: 'configurator'
    },
    {
        key: '3D-product-configurator-scene-editor',
        url: backofficeUrl('/product/3D-product-configurator-scene-editor'),
        title: T._('Scene Editor', 'Admin'),
        component: SceneEditor,
        inEdit: true,
        mode: 'configurator'
    },
    {
        key: '3D-product-configurator-composer',
        url: backofficeUrl('/product/3D-product-configurator-composer'),
        title: T._('Composer', 'Admin'),
        component: Composer,
        inEdit: true,
        mode: 'configurator'
    },
    {
        key: '3D-product-configurator-shopping-preview',
        url: backofficeUrl('/product/3D-product-configurator-shopping-preview'),
        title: T._('Shopping Preview', 'Admin'),
        component: ShoppingPreview,
        inEdit: true,
        mode: 'configurator'
    },
    {
        key: 'import-catalog',
        url: backofficeUrl('/product/import-catalog'),
        title: T._('Import Catalog', 'Admin'),
        component: ImportCatalog,
        inEdit: false,
        mode: 'pod'
    },
    {
        key: 'import-configuration',
        url: backofficeUrl('/product/import-configuration'),
        title: T._('Configuration', 'Admin'),
        component: ImportConfiguration,
        inEdit: false,
        mode: 'pod'
    },
    {
        key: 'edit-configuration',
        url: backofficeUrl('/product/edit-configuration'),
        title: T._('Configuration', 'Admin'),
        component: EditConfiguration,
        inEdit: true,
        mode: 'pod'
    },
    { key: 'done', url: backofficeUrl('/product/done'), title: T._('Done!', 'Admin'), component: Done, inEdit: true, mode: 'classic' },
    { key: 'pod-done', url: backofficeUrl('/product/pod-done'), title: T._('Done!', 'Admin'), component: PodDone, inEdit: false, mode: 'pod' }
] as const;

export default pages;
